const binding = { modules: {}, dataActions: {} };

    (binding.modules['mtt-content-block'] = {
        c: () => require('partner/modules/mtt-content-block/mtt-content-block.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'mtt-content-block',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/mtt-content-block'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|mtt-content-block|mtt-content-block'] = {
                c: () => require('partner/modules/mtt-content-block/mtt-content-block.view.tsx'),
                cn: '__local__-__local__-mtt-content-block'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };